import React, { useCallback, useRef } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import GetAppIcon from "@mui/icons-material/GetApp";
import jsPDF from "jspdf";
import { Box, Typography } from "@mui/material";
import {
  Governance,
  Social,
  Environmental,
} from "utils/MaterialityAssessmentUtils/materialityAssessmentUtils";

import { makeStyles } from "@mui/styles";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export function RadarChart(props) {
  const { allData, category } = props;
  const { environmentObj, socialObj, governanceObj } = allData;
  const { ChartTabNo } = props;

  const bgColor = {
    id: "bgColor",
    beforeDraw: (chart) => {
      const { ctx, width, height } = chart;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    },
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 1,
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  const EsgScoreLeftStyles = makeStyles((theme) => ({
    cardContainer: {
      backgroundColor: "#FFFFFF",
      borderRadius: 5,
      // height:'100%'
    },
    mainHeadder: {
      display: "flex",
      justifyContent: "space-between",
      margin: "8px 0px 8px 0px",
    },
    Typography: {
      fontWeight: 600,
      fontSize: "16px",
      marginLeft: "10px",
    },
    Typography2: {
      fontWeight: 600,
      fontSize: "16px",
      marginLeft: "4px",
    },
    iconCont: {
      display: "flex",
      justifyContent: "space-evenly",
    },
    cursorPointer: {
      cursor: "pointer",
    },
    headerIcon: {
      marginRight: "20px",
    },
    Table: {
      outline: "0.5px solid rgba(0,0,0,0.05)",
      borderRadius: "5px",
      // boxShadow: "1px 1px 1px",
      height: "100%",
    },
    TableContainer: {
      padding: "3px",
    },
    TableCell: {
      padding: "5px",
      border: "none",
    },
    hedaderCell: { color: "grey", fontSize: "x-small" },
    topicCell: { padding: "4px 4px" },
    lableCell: {
      // width: '193px',
      // height: '20px',
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "14px",
      // lineHeight: "20px",
    },
    scoreCell: {
      textAlign: "right",
      // width: '32px',
      // height: '28px',
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "22px",
      lineHeight: "28px",
    },
    SuggestionBtn: {
      textTransform: "none",
      textAlign: "center",
      width: "100%",
      fontFamily: "Poppins",
      margin: "5% 0px 5px 1px",
      padding: "5px",
    },
    contributorGrid: {
      padding: "0px 15px 0px 10px",
    },
    contributorsBtn: {
      backgroundColor: "white",
      color: "green",
      border: "0.5px solid green",
      borderRadius: "5px",
      textTransform: "none",
      textAlign: "center",
      width: "100%",
      fontFamily: "Poppins",
      margin: "5% 0px 5px 1px",
    },
    topicStyle: {
      width: "40px",
      height: "40px",
      marginTop: "5px",
      position: "relative",
      top: "5px",
    },
    levelImg: {
      width: "140px",
      height: "135px",
    },
    ".MuiLinearProgress-root": {
      color: "green",
    },
    LinearProgress: {
      // color:'success.main',
      margin: "-5px 25px 25px 25px",
    },
    scoreTypo: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "xx-large",
    },
    maxScoreTypo: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 400,
    },
    sharesurvey: {
      color: "#222",
      fontSize: "12px",
      backgroundColor: "#BFE2CD",
      padding: "10px",
      borderRadius: "100px",
    },
    describe: {
      color: "grey",
      fontSize: "x-small",
      marginTop: "11px",
    },
    scoreImage: {
      width: "200px",
      height: "190px",
    },
    mainGrid: {
      textAlign: "center",
    },
    discribe: {
      fontSize: "small",
    },
    slider: {
      ".MuiSlider-root": {
        color: "#20b2aa",
      },
      ".MuiSlider-root:hover": {
        color: "#2e8b57",
      },
    },
    levelTypo: {
      // marginLeft: "5%",
      textAlign: "center",
    },
    progressIndicator1: {
      position: "relative",
      left: "33%",
      top: "12px",
      backgroundColor: "rgb(0 128 0)",
      zIndex: 1,
    },
    progressIndicator2: {
      position: "relative",
      left: "66.7%",
      top: "12px",
      backgroundColor: "rgb(0 128 0)",
      zIndex: 1,
    },
    [theme.breakpoints.down("lg")]: {
      SuggestionBtn: {
        margin: "5% 0px 5px 1px",
      },
      discribe: {
        fontSize: "small",
        textWrap: "no-wrap",
        wordWrap: "no-wrap",
      },
    },
    [theme.breakpoints.down("md")]: {
      SuggestionBtn: {
        margin: "5% 0px 5px 1px",
        padding: "5px",
      },
      contributorsBtn: {
        margin: "5% 0px 5px 1px",
        paddingLeft: "5px",
      },
      discribe: {
        textAlign: "left",
        fontSize: "small",
        textWrap: "no-wrap",
        wordWrap: "no-wrap",
      },
      sharesurvey: {
        fontWeight: 500,
      },
    },
    leftTop: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
    },
  }));
  const classes = EsgScoreLeftStyles();
  const categoryIcons = {
    Environment: <Environmental className={classes.topicStyle} />,
    Social: <Social className={classes.topicStyle} />,
    Governance: <Governance className={classes.topicStyle} />,
  };
  const getOverallData = () => {
    const labels = ["Environment", "Social Capital", "Leadership & Governance"];
    const dataSetValues = [
      environmentObj?.fraction_value || 0,
      socialObj?.fraction_value || 0,
      governanceObj?.fraction_value || 0,
    ];
    return {
      labels,
      datasets: [
        {
          label: `Overall`,
          data: dataSetValues,
          backgroundColor: "rgba(255, 99, 0, 0.15)",
          borderColor: "rgba(255, 99, 132, 1)",
          borderWidth: 1,
        },
      ],
    };
  };

  const getData = (dataObject) => {
    const subCategories =
      dataObject?.sub_subcategory || dataObject?.sub_category || [];
    const labels = subCategories.map((sub) => sub.category);
    const dataSetValues = subCategories.map((sub) => sub.fraction_value);

    let backgroundColor = "rgba(0, 0, 0, 0.1)";
    let borderColor = "blue";
    switch (dataObject?.category?.toLowerCase()) {
      case "environment":
        backgroundColor = "rgba(200, 230, 201, 0.3)"; // Green 100 with transparency
        borderColor = "#81C784"; // Green 300
        break;
      case "energy management":
        backgroundColor = "rgba(200, 230, 201, 0.3)";
        borderColor = "#87BB62";
        break;
      case "water management":
        backgroundColor = "rgba(200, 230, 201, 0.3)";
        borderColor = "#63993D";
        break;
      case "waste management":
        backgroundColor = "rgba(200, 230, 201, 0.3)"; // green
        borderColor = "#3D7317";
        break;
      case "natural resources":
        backgroundColor = "rgba(200, 230, 201, 0.3)"; // green
        borderColor = "#204D00";
        break;
      case "ghg emissions":
        backgroundColor = "rgba(200, 230, 201, 0.3)"; // green
        borderColor = "#204D05";
        break;

      case "social":
        backgroundColor = "rgba(225, 190, 231, 0.3)";
        borderColor = "#B6A6E9";
        break;
      case "occupational health & safety":
        backgroundColor = "rgba(225, 190, 231, 0.3)";
        borderColor = "#876FD4";
        break;
      case "labour strategy & benefits":
        backgroundColor = "rgba(225, 190, 231, 0.3)";
        borderColor = "#5E40BE";
        break;
      case "governance":
        backgroundColor = "rgba(187, 222, 251, 0.3)";
        borderColor = "#92C5F9";
        break;
      case "supplier management":
        backgroundColor = "rgba(187, 222, 251, 0.3)";
        borderColor = "#4394E5";
        break;
      case "procurement practices":
        backgroundColor = "rgba(187, 222, 251, 0.3)";
        borderColor = "#0066CC";
        break;
    }
    return {
      labels,
      datasets: [
        {
          label: `${dataObject?.category}`,
          data: dataSetValues,
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          borderColor,
          borderWidth: 1,
        },
      ],
    };
  };

  const ref = useRef(null);
  const refC1 = useRef(null);
  const refC2 = useRef(null);
  const refC3 = useRef(null);

  const download = useCallback((ref) => {
    const canvas = ref.current;
    const canvasImage = canvas.toBase64Image();
    let pdf = new jsPDF();
    pdf.addImage(canvasImage, "JPEG", 20, 20, 185, 150);
    pdf.save("mychart.pdf");
  }, []);

  return (
    <Box
      style={{
        display: "flex",
        gap: "30px",
        padding: "10px",
        height: "450px",
      }}
    >
      {/* LEFT SIDE - Radar Chart */}
      <Box
        style={{
          flex: "0 0 400px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {ChartTabNo === 0 && (
          <>
            <GetAppIcon
              style={{
                alignSelf: "flex-end",
                cursor: "pointer",
                marginBottom: "5px",
              }}
              onClick={() => download(ref)}
            />
            <Box style={{ width: "700px", height: "400px" }}>
              <Radar ref={ref} options={options} data={getOverallData()} />
            </Box>
          </>
        )}

        {ChartTabNo === 1 && environmentObj && (
          <>
            <GetAppIcon
              style={{
                alignSelf: "flex-end",
                cursor: "pointer",
                marginBottom: "5px",
              }}
              onClick={() => download(refC1)}
            />
            <Box style={{ width: "700px", height: "400px" }}>
              <Radar
                ref={refC1}
                options={options}
                data={getData(environmentObj)}
              />
            </Box>
          </>
        )}

        {ChartTabNo === 2 && socialObj && (
          <>
            <GetAppIcon
              style={{
                alignSelf: "flex-end",
                cursor: "pointer",
                marginBottom: "5px",
              }}
              onClick={() => download(refC2)}
            />
            <Box style={{ width: "700px", height: "400px" }}>
              <Radar ref={refC2} options={options} data={getData(socialObj)} />
            </Box>
          </>
        )}

        {ChartTabNo === 3 && governanceObj && (
          <>
            <GetAppIcon
              style={{
                alignSelf: "flex-end",
                cursor: "pointer",
                marginBottom: "5px",
              }}
              onClick={() => download(refC3)}
            />
            <Box style={{ width: "700px", height: "400px" }}>
              <Radar
                ref={refC3}
                options={options}
                data={getData(governanceObj)}
              />
            </Box>
          </>
        )}
      </Box>

      {/* RIGHT SIDE - Category List */}
      <Box
        style={{
          flex: 1,
          paddingLeft: "10px",
          overflowY: "auto",
        }}
      >
        {/* Display Main Category with Value */}
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px", // more spacing after main title
            borderBottom: "2px solid #ccc",
            paddingBottom: "8px",
          }}
        >
          <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {categoryIcons[category?.category] || null}
            <Typography
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#222",
                marginTop: "10px",
              }}
            >
              {category?.category}
            </Typography>
          </Box>
          <Typography
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#222",
              marginTop: "10px",
            }}
          >
            {category?.normalized_value ??
              Math.round(category?.fraction_value * 100)}
          </Typography>
        </Box>

        {/* List of Subcategories */}
        {(Array.isArray(category?.sub_category)
          ? category.sub_category
          : category?.sub_subcategory || []
        ).map((mainCat, idx) => (
          <Box
            key={idx}
            style={{
              marginBottom: "20px", // increased spacing between rows
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "6px",
              // borderBottom: "1px solid #eee",
            }}
          >
            <Typography style={{ fontSize: "12px", color: "#444" }}>
              {mainCat.category}
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: 500 }}>
              {mainCat.normalized_value ?? Math.round(mainCat.fraction_value)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default RadarChart;
